import Stack from "@mui/material/Stack";
import { useSearchParams } from "react-router-dom";
import { LojaPageContainer } from "../../common";
import ExtratoFinanceiroSection from "../dashboard/components/ExtratoFinanceiroSection";
import { useContasFinanceirasFinanceiro } from "../dashboard/hooks/useContasFinanceirasFinanceiro";
import { useExtratoFinanceiro } from "../dashboard/hooks/useExtratoFinanceiro";

/**
 * Movimentação Financeira — movimentações com filtros avançados e paginação.
 */
export default function LojaFinanceiroExtratoFinanceiroPage() {
  const [searchParams] = useSearchParams();
  const contaInicial = searchParams.get("conta") ?? undefined;
  const extratoFinanceiro = useExtratoFinanceiro({
    contaFinanceiraIdInicial: contaInicial,
  });
  const contasFinanceirasFinanceiro = useContasFinanceirasFinanceiro();

  return (
    <LojaPageContainer
      title="Movimentação Financeira"
      subtitle="Entradas, saídas, taxas, transferências e ajustes no período e filtros selecionados."
    >
      <Stack spacing={3}>
        <ExtratoFinanceiroSection
          embedded
          extrato={extratoFinanceiro}
          contasFinanceiras={contasFinanceirasFinanceiro}
        />
      </Stack>
    </LojaPageContainer>
  );
}
